import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import TimelineItem from "examples/Timeline/TimelineItem";
import AuthService from "services/auth-service";
import { useMaterialUIController } from "context";
import moment from "moment";

function InfoSummary() {
  const [controller] = useMaterialUIController();
  const { wallets, accounts } = controller;
  const [ccSpend, setCcSpend] = useState(0);
  const [items, setItems] = useState([]);

  useEffect(() => { loadCurrentCreditCardSpends() }, [accounts]);
  useEffect(() => { loadTotalSummaryPerWallet() }, [wallets]);

  const loadTotalSummaryPerWallet = async () => {
    setItems([]);
    if (Array.isArray(wallets) && wallets.length > 0) {
      const results = await Promise.all(wallets.map((wallet, index) => fetchTotalSummary(wallet, index)));
      setItems(results.flat());
    }
  };

  const fetchTotalSummary = async (wallet, index) => {
    const color = ["success", "info", "primary", "secondary"];
    let payload = {
      wallet_id: wallet.id,
      month: moment().format('YYYYMM'),
    };
    let total = await AuthService.fetchSummariesTotal("first_day_snapshot", payload) ?? 0;
    const totalNow = new Intl.NumberFormat("en-US", {style: "currency", currency: ("USD"), minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Math.abs(total) / 100)

    payload = {
      wallet_id: wallet.id,
      month: moment().format('YYYY') + "01",
    };
    total -= await AuthService.fetchSummariesTotal("first_day_snapshot", payload) ?? 0;
    const totalSave = new Intl.NumberFormat("en-US", {style: "currency", currency: ("USD"), minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Math.abs(total) / 100)
    const avgSave = new Intl.NumberFormat("en-US", {style: "currency", currency: ("USD"), minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Math.abs(total/moment().format("M")) / 100)
    
    return [
      {
        key: wallet.id+"total",
        color: color[index % color.length],
        icon: "monetization_on",
        title: `${totalNow} in ${wallet.name} ${moment().format('MM/YYYY')}`
      },
      {
        key: wallet.id+"save",
        color: color[index % color.length],
        icon: "price_change",
        title: `${totalSave} (${avgSave}/month) total saved on ${wallet.name} ${moment().format('YYYY')}`
      }
    ];
  };

  const loadCurrentCreditCardSpends = async () => {
    const ccSpends = await Promise.all(accounts.filter((account) => account.type === "card").map(async (account) => {
      return await fetchTotalTransactions(account);
    }));
    
    let totalSpends = ccSpends.reduce((sum, current) => sum + current, 0);
    totalSpends = new Intl.NumberFormat("en-US", {style: "currency", currency: (accounts[0]?.currency ?? "USD"), minimumFractionDigits: 2, maximumFractionDigits: 2}).format(Math.abs(totalSpends) / 100)
    setCcSpend(totalSpends);
  };

  const fetchTotalTransactions = async (account) => {
    const month_gap = moment().format('D') < account.start_day ? -1 : 0;
    const payload = {
      from: moment().set("date", account.start_day).add(month_gap, "month").format("YYYY-MM-DD"),
      to: moment().set("date", account.start_day).add(month_gap + 1, "month").format("YYYY-MM-DD"),
      accounts: [account.id],
    };
    const response = await AuthService.fetchTotalTransactions(payload);
    return response ?? 0;
  };

  return (
    <Card sx={{ boxShadow: "none", height: "100%" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Orders overview
        </MDTypography>
      </MDBox>
      <MDBox p={2}>
        {items?.map((item) => (
          <TimelineItem
            key={item.key}
            icon={item.icon}
            title={item.title}
            color={item.color}
          />
        ))}
        <TimelineItem
          key="123re"
          color="error"
          icon="credit_card"
          title={`Credit card spend on current month ${ccSpend}`}
          lastItem
        />
      </MDBox>
    </Card>
  );
}

export default InfoSummary;
